import { getAppI18nConfig, initI18n } from 'cfgi18n';
import { GetServerSideProps } from 'next';

import { getPlayers, GetPlayersResponse } from 'services/players';

import { Seo } from 'core/mancity/components/general/seo';

import { LandingLayout } from '../layouts/landing';

export type IndexProps = {
	playersData: GetPlayersResponse;
};

export default function Index({ playersData }: IndexProps) {
	return (
		<>
			{playersData.head && <Seo head={playersData.head} />}
			<LandingLayout team={'mens'} data={playersData} />
		</>
	);
}

export const getServerSideProps: GetServerSideProps = async (context) => {
	const locale = context.locale as string;

	const { supportedLocales } = await getAppI18nConfig('players');
	await initI18n(locale, supportedLocales);

	const response = await getPlayers('mens', locale);

	if (!response.data || !response.data.body.length) {
		return {
			notFound: true,
		};
	}

	return {
		props: {
			playersData: response.data,
			locale,
		},
	};
};
